import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/iconPlaybackRate0_5x.svg'

export const IconPlaybackRate0_5x = IconSVG as IconComponent
